import script from "./HomeC.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeC.vue?vue&type=script&setup=true&lang=js"

import "./HomeC.vue?vue&type=style&index=0&id=0aaa1f14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aaa1f14"]])

export default __exports__